/**
 * UNRAVEL - cart line controls + recommendation strip.
 *
 * Shared by the drawer and the cart page: the drawer snippet only renders on
 * non-cart templates, so keeping these here is what makes quantity, remove and
 * the upsell rail work in both places.
 */

  (function () {
    // Reward-ladder Apply button: force navigation so the cart-drawer can't swallow the click.
    if (!window.__uvLadderApplyBound) {
      window.__uvLadderApplyBound = true;
      document.addEventListener('click', function (e) {
        var el = e.target.closest && e.target.closest('.uv-ld__apply');
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        var code = el.getAttribute('data-code');
        var url = el.getAttribute('href') || ('/discount/' + code + '?redirect=/cart');
        el.textContent = 'Applying…';
        window.location.href = url;
      }, true);
    }
    if (window.customElements.get('uv-cart-upsell')) return;
    var money = function (cents) {
      try { return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }); }
      catch (e) { return '₹' + Math.round(cents / 100); }
    };
    var esc = function (t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
    var escAttr = function (t) { return esc(t).replace(/"/g, '&quot;'); };
    // Turn the long marketing title into a short, recognisable hint + ellipsis.
    var shortName = function (title) {
      var full = String(title || '').replace(/\s+/g, ' ').trim();
      var s = full.split('|')[0].trim();                 // drop "| Comparable to ... | Premium ..."
      var m = s.match(/^(.*?)\s+inspired\b/i);            // for "X Inspired Perfume Oil", keep just X
      if (m && m[1]) s = m[1].trim();
      if (s.length > 26) {
        var cut = s.slice(0, 26).replace(/\s+\S*$/, ''); // back off to last whole word
        s = (cut || s.slice(0, 26)) + '…';
      } else if (s.length < full.length) {
        s += '…';                                         // signal a fuller name exists
      }
      return s;
    };
    class UvCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this._loaded) return;
        this._loaded = true;
        this.render();
      }
      async render() {
        var seed = this.dataset.seed;
        if (!seed) return;
        var root = (this.dataset.root || '/').replace(/\/$/, '');
        var inCart = (this.dataset.incart || '').split(',').filter(Boolean);
        var limit = parseInt(this.dataset.limit || '6', 10);
        var rail = this.querySelector('[data-rail]');
        try {
          var url = root + '/recommendations/products.json?product_id=' + encodeURIComponent(seed) + '&limit=10&intent=related';
          var res = await fetch(url);
          if (!res.ok) return;
          var data = await res.json();
          var products = (data.products || []).filter(function (p) {
            return inCart.indexOf(String(p.id)) === -1 && p.available !== false;
          }).slice(0, limit);
          if (!products.length) return;
          var frag = document.createDocumentFragment();
          products.forEach(function (p) {
            var variant = (p.variants || []).find(function (v) { return v.available; }) || (p.variants || [])[0];
            if (!variant) return;
            var card = document.createElement('div');
            card.className = 'uv-up-card';
            var img = p.featured_image || (p.images && p.images[0]) || '';
            card.innerHTML =
              (img ? '<img class="uv-up-card__img" src="' + img + '" alt="" loading="lazy" width="34" height="40">' : '<span class="uv-up-card__img"></span>') +
              '<div class="uv-up-card__body">' +
                '<a class="uv-up-card__name" title="' + escAttr(p.title) + '" href="' + p.url + '">' + esc(shortName(p.title)) + '</a>' +
                '<div class="uv-up-card__meta">' +
                  '<span class="uv-up-card__price">' + money(p.price) + '</span>' +
                  (document.documentElement.hasAttribute('data-orders-paused')
                    ? ''
                    : '<button type="button" class="uv-up-card__add" data-vid="' + variant.id + '">Add</button>') +
                '</div>' +
              '</div>';
            frag.appendChild(card);
          });
          rail.appendChild(frag);
          this.hidden = false;
          this.addEventListener('click', this.onAdd.bind(this));
        } catch (e) { /* silent */ }
      }
      async onAdd(e) {
        if (document.documentElement.hasAttribute('data-orders-paused')) return;
        var btn = e.target.closest('.uv-up-card__add');
        if (!btn) return;
        e.preventDefault();
        var root = (this.dataset.root || '/').replace(/\/$/, '');
        btn.disabled = true; btn.textContent = 'Adding…';
        try {
          var res = await fetch(root + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.vid, 10), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('add failed');
          if (this.closest('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } else {
            window.location.reload();
          }
        } catch (err) {
          btn.disabled = false; btn.textContent = 'Add';
        }
      }
    }
    window.customElements.define('uv-cart-upsell', UvCartUpsell);
  })();


  /* UNRAVEL - drawer cart mutations on Horizon shell (custom). */
  (function () {
    function refresh(then) {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer-section' : '/?sections=cart-drawer-section')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer-section'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-uv-cart]');
          var cur = document.querySelector('#cart-drawer [data-uv-cart]');
          if (next && cur) cur.replaceWith(next);
          import('https://cdn.shopify.com/storefront/standard-events.js').then(function (m) {
            document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'update', context: 'cart-drawer', lines: [] }));
          }).catch(function () {});
          if (then) then();
        }).catch(function () {});
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-uv-qty], [data-uv-remove], [data-uv-save-note]');
      if (!btn || !(btn.closest('#cart-drawer') || btn.closest('.uv-cartpage'))) return;
      e.preventDefault();
      if (btn.hasAttribute('data-uv-save-note')) {
        var ta = document.getElementById('uv-cart-note');
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Unravel-Source': 'cart-drawer' }, body: JSON.stringify({ note: ta ? ta.value : '' }) })
          .then(function () { var d = btn.closest('details'); if (d) d.open = false; });
        return;
      }
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qty = btn.hasAttribute('data-uv-remove') ? 0 : parseInt(btn.getAttribute('data-uv-qty'), 10);
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Unravel-Source': 'cart-drawer' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function () {
          if (document.body.classList.contains('template-cart') || window.location.pathname.endsWith('/cart')) {
            fetch(window.location.pathname + '?sections=cart-section')
              .then(function (r) { return r.json(); })
              .then(function (data) {
                var html = data['cart-section'];
                if (!html) return window.location.reload();
                var next = new DOMParser().parseFromString(html, 'text/html').querySelector('.uv-cartpage');
                var cur = document.querySelector('.uv-cartpage');
                if (next && cur) cur.replaceWith(next); else window.location.reload();
              })
              .catch(function () { window.location.reload(); });
            return;
          }
          refresh();
        });
    });
    /* keep drawer content fresh when other components add to cart */
    import('https://cdn.shopify.com/storefront/standard-events.js').then(function (m) {
      document.addEventListener(m.StandardEvents ? m.StandardEvents.cartLinesUpdate : 'cart-lines-update', function (ev) {
        if (ev && ev.detail && ev.detail.context === 'cart-drawer') return; /* our own event */
        refresh();
      });
    }).catch(function () {});
  })();
